import React from 'react';
import {
  DialogContent as MuiDialogContent,
  IconButton,
  DialogTitle,
  Box,
  Typography,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import StyledPinnacleDialog from './PinnacleDialog.styled';
import { handleDialogClose } from './PinnacleDialog.helpers';
import { PinnacleDialogProps } from './PinnacleDialog.types';

export const PinnacleDialog: React.FC<PinnacleDialogProps> = (props) => {
  const {
    isOpen,
    setIsOpen,
    disableBackDropClick,
    children,
    dialogSize = 'medium',
    headerTitle,
    ...rest
  } = props;

  // Decide width based on the flag
  let maxWidth;
  let maxHeight = '80vh'; // default

  switch (dialogSize) {
    case 'small':
      maxWidth = 400;
      break;
    case 'medium':
      maxWidth = 500;
      break;
    case 'large':
      maxWidth = 700;
      break;
    case 'full':
      maxWidth = '100%';
      maxHeight = '100%';
      break;
    default:
      maxWidth = 500;
  }

  return (
    <StyledPinnacleDialog
      {...rest}
      open={!!isOpen}
      onClose={(_, reason: string) =>
        setIsOpen
          ? handleDialogClose(reason, setIsOpen, disableBackDropClick ?? false)
          : undefined
      }
      slotProps={{
        paper: {
          sx: {
            width: '100%',
            maxWidth,
            height: 'auto',
            maxHeight,
            borderRadius: 2,
          },
        },
      }}
    >
      <MuiDialogContent>
        {/* Header title */}
        <DialogTitle sx={{ p: 0 }}>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              pr: 1,
              mb: 3,
            }}
          >
            <Typography sx={{ color: "#373737", fontSize: "20px", fontWeight: 400 }}>
              {headerTitle}
            </Typography>
            <IconButton
              aria-label="close"
              onClick={() => setIsOpen?.(false)}
              sx={{
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>

        {children}

      </MuiDialogContent>
    </StyledPinnacleDialog>
  );
};
